import type { RiskBandSet } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';
import { ErrorCodes } from 'errors';

import { ApiError } from 'api/api-util/api-error';
import { RiskBandsApi } from 'api/RiskBandsApi';
import { RISK_BANDS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useRiskBandSet(riskBandSetId?: string) {
  const riskBandsApi = new RiskBandsApi();
  const { userBankId } = useUser();

  const {
    data: riskBandSet,
    isLoading: isLoadingRiskBandSet,
    isError: isErrorRiskBandSet
  } = useQuery<RiskBandSet | null>({
    enabled: !!userBankId.length && !!riskBandSetId,
    queryKey: [RISK_BANDS_KEY, userBankId, 'record', riskBandSetId],
    queryFn: async () => {
      try {
        return await riskBandsApi.getRiskBandSet(userBankId, riskBandSetId as string);
      } catch (error) {
        if (error instanceof ApiError && error.code === ErrorCodes.NotFound) {
          return null;
        }
        throw error;
      }
    }
  });

  return {
    riskBandSet: riskBandSet ?? undefined,
    isMissingRiskBandSet: riskBandSet === null,
    isLoadingRiskBandSet,
    isErrorRiskBandSet
  };
}
